import { render, staticRenderFns } from "./QRCode-ServiceCall.vue?vue&type=template&id=d53a0c1e&"
import script from "./QRCode-ServiceCall.vue?vue&type=script&lang=js&"
export * from "./QRCode-ServiceCall.vue?vue&type=script&lang=js&"
import style0 from "./QRCode-ServiceCall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/QRCode-ServiceCall.vue
// module id = null
// module chunks = 